import React from 'react';

export default function Pagination({ pagination, page, onChange }) {
  const { totalPages = 1, totalDocs = 0 } = pagination || {};
  return (
    <div className="flex items-center justify-between text-sm text-slate-500 mt-3">
      <span>{totalDocs.toLocaleString('es-MX')} registros</span>
      <div className="flex items-center gap-2">
        <button
          className="px-2 py-1 rounded border border-slate-300 disabled:opacity-40"
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
        >
          ‹
        </button>
        <span>Página {page} de {totalPages || 1}</span>
        <button
          className="px-2 py-1 rounded border border-slate-300 disabled:opacity-40"
          disabled={page >= totalPages}
          onClick={() => onChange(page + 1)}
        >
          ›
        </button>
      </div>
    </div>
  );
}
